import { useNavigate } from "react-router-dom";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import { Banner, BlueLarge } from "../../images/index";
import {
  FinancialImage,
  Image298,
  Image299,
  Image300,
  Image342,
} from "../../images/Industries";
import { useEffect, useState } from "react";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";

const challenges = [
  "Legacy core banking and insurance systems",
  "Complex compliance and regulatory requirements (SOX, PCI DSS, GDPR)",
  "CyberSecurity threats targeting sensitive financial data",
  "Rising customer expectations for digital-first services",
  "High operational costs from manual and repetitive processes",
];

const finance = [
  "Proven experience with Fortune 500 financial institutions",
  "Certified MWBE, ISO 9001:2015, Microsoft Gold Partner",
  "Hybrid U.S.–India delivery model for 24/7 support",
  "Deep domain knowledge in compliance, risk, and security",
];

function FS() {
  const navigate = useNavigate();
  const slug = useSlug();
  const [metaData, setMetaData] = useState({});
  useEffect(() => {
    const fetchMetaData = async () => {
      const data = await getPagesBySlug(slug);
      setMetaData(data?.meta || {});
    };
    fetchMetaData();
  }, [slug]);

  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[500px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-[56rem] font-roboto space-y-6 mt-16">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569]">Financial Services</span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Intelligent Financial Solutions
              </h1>
              <p className="text-md text-[#404040] max-w-3xl">
                TechProjects helps banks, insurers, and financial institutions
                modernize operations, stay compliant, and deliver smarter
                customer experiences through digital transformation.
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-16">
              <img src={Image342} alt="Image" className="obkect-contain" />
            </div>
          </div>
        </div>

        <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="mb-12">
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Industry Challenges
              </h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 w-full mb-10">
                <ul className="space-y-7 ms-5">
                  {challenges.map((item, idx) => (
                    <li
                      key={idx}
                      className="list-disc text-xl text-[#0F172A] font-medium"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex-1 flex items-center justify-center">
                <img
                  src={Image298}
                  alt="Idea Concept"
                  className="max-w-md w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 px-4 md:px-20 font-roboto bg-white">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="max-w-4xl mx-auto mb-12 text-center">
              <span className="flex items-center justify-center font-bold text-lg tracking-wider mb-4 space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Our Financial Solutions
              </h2>
              <p className="text-[#404040] font-400 text-lg text-base">
                We empower businesses with AI-driven tools and automation that
                optimize operations, enhance customer experiences, and unlock
                measurable value across the supply chain:
              </p>
            </div>
            <img
              src={FinancialImage}
              alt="Our Supply Chain Solutions"
              className="inset-0 -z-10 md:h-full w-full object-cover"
            />
            <a
              href="#"
              className="text-[#FA3746] text-xl font-bold flex items-center w-full justify-center gap-2"
            >
              Explore Our Services{" "}
              <i className="fa fa-arrow-right text-xs mt-1"></i>
            </a>
          </div>
        </section>

        <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="mb-12">
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Why TechProjects for Finance?
              </h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 w-full mb-10">
                <ul className="space-y-7 ms-5">
                  {finance.map((item, idx) => (
                    <li
                      key={idx}
                      className="list-disc text-xl text-[#0F172A] font-medium"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex-1 flex items-center justify-center">
                <img
                  src={Image299}
                  alt="Idea Concept"
                  className="max-w-md w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto bg-white py-16 px-2 font-roboto">
          <div className="flex justify-center mb-3">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>

          <h2 className="text-4xl md:text-7xl font-extrabold text-[#434253] text-center mb-4">
            Impact & Case Studies
          </h2>

          <div className="text-center text-lg text-[#404040] mx-auto max-w-5xl mb-12 font-400">
            We partner with financial institutions to enhance security, speed,
            and efficiency. Here are a few examples of how TechProjects is
            driving impact in banking and payments.
          </div>

          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="flex-1 flex justify-center">
              <img
                src={Image300}
                alt="Case studies discussion"
                className="object-cover w-full max-w-md"
              />
            </div>
            <div className="flex-1 px-8 md:px-0">
              <ul className="list-disc space-y-4 text-lg text-[#0F172A]">
                <li>
                  <span className="font-bold">Banking Client</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>40% faster approvals</li>
                    <li>
                      Automated loan processing workflows, cutting approval
                      times and improving customer experience.
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold">Payments Provider</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>25% less fraud</li>
                    <li>
                      Built an AI-driven fraud detection system that
                      strengthened transaction security and reduced fraud.
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold">Financial Institution</span>
                  <ul className="list-disc ml-5 mt-2 text-base text-lg text-[#475569]">
                    <li>Scalable, cost-efficient systems</li>
                    <li>
                      Migrated core banking platforms to the cloud, improving
                      performance and lowering operational costs.
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-4xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Financial Services
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1] max-w-3xl  mx-auto">
              With TechProjects, you can strengthen risk controls, increase
              operational efficiency, and deliver tailored client experiences —
              enabled by AI and intelligent automation.
            </p>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Contact Us Now
              </button>
            </div>
          </div>
        </section>

        <ScrollToTopButton />
      </div>
    </>
  );
}

export default FS;
